import { Injectable } from "@angular/core";
import { Subject, NextObserver, Subscription } from "rxjs";
import { HistoryItemPeriod } from '../../interfaces/historyItem';
import { MobileMainView } from "../../enums/mobile-mainViews";


@Injectable()
export class GlobalGridModeService  {
    public symbolChangedSubscriber: Subject<{symbol: string, overrideLockAllCharts?: boolean, refreshperiod?:boolean}> = new Subject<{symbol: string, overrideLockAllCharts?: boolean, refreshperiod?:boolean}>();
    private showGridSubscriber: Subject<boolean> = new Subject<boolean>();

    public showPriceIndicatorSubscriber: Subject<boolean> = new Subject<boolean>();
    public showtradeLinesSubscriber: Subject<boolean> = new Subject<boolean>();
    public showIndicatorLinesSubscriber: Subject<boolean> = new Subject<boolean>();
    public lockAllCharsSubscriber: Subject<boolean> = new Subject<boolean>();
    
    public isSelectedChart:Subject<boolean> = new Subject<boolean>();
    public longSymbolPeriod: Subject<HistoryItemPeriod> = new Subject<HistoryItemPeriod>();
    public midSymbolPeriod: Subject<HistoryItemPeriod> = new Subject<HistoryItemPeriod>();
    public shortSymbolPeriod: Subject<HistoryItemPeriod> = new Subject<HistoryItemPeriod>();
    public entrySymbolPeriod: Subject<HistoryItemPeriod> = new Subject<HistoryItemPeriod>();
    public volumeOpened: Subject<string> = new Subject<string>();
    public sendOrderGridChange: Subject<string> = new Subject<string>();
    public sendHistoryOrderGridChange: Subject<string> = new Subject<string>();
    public changeActiveBasket: Subject<number> = new Subject<number>();
    public sendModelChange: Subject<number> = new Subject<number>();
    public sendModelChangeParametersSet: Subject<number> = new Subject<number>();
    public activeAccountIdBySetSubscriber: Subject<number> = new Subject<number>();
    public sendModelNewUserSet: Subject<number> = new Subject<number>();
    public UserListUpdate: Subject<number> = new Subject<number>();
    public mobileViewUpdate: Subject<string> = new Subject<string>();
    public showLoaderComponent: Subject<boolean> = new Subject<boolean>();
    public loadedTournaments:Subject<boolean>  = new Subject<boolean>();
    public activePicker:Subject<string>  = new Subject<string>();
    public dateFilter:Subject<string>  = new Subject<string>();
    public historyUpdate:Subject<string>  = new Subject<string>();
    public dateFilterChallenge:Subject<string>  = new Subject<string>();
    public funnelUserActive:Subject<boolean>  = new Subject<boolean>();
    public scanFinished:Subject<number>  = new Subject<number>();
    public upcomingCLoseSignal:Subject<any>  = new Subject<any>();
    public changeScannerSide:Subject<any>  = new Subject<any>();
    public changeScannerNarrowSide:Subject<any>  = new Subject<any>();
    public runNarrowScanProcess:Subject<any>  = new Subject<any>();
    public changeScannerPeriod:Subject<any>  = new Subject<any>();
    public loadScannerRule:Subject<any>  = new Subject<any>();
    public updateScanList:Subject<any>  = new Subject<any>();
    public refreshProviderSignal:Subject<any>  = new Subject<any>();
    public scannerReminderLauncher:Subject<any>  = new Subject<any>();
    public scannerTrialLauncher:Subject<any>  = new Subject<any>();
    public appSuccessNotification:Subject<any>  = new Subject<any>();
    public switchProviderSignal:Subject<any>  = new Subject<any>();
    public setPopScan:Subject<any>  = new Subject<any>();
    public registrationScanner:Subject<any>  = new Subject<any>();
    public liveLoginAction:Subject<any>  = new Subject<any>();
    public fullScreenScanerAction:Subject<string>  = new Subject<string>();
    public tradeTab:Subject<string>  = new Subject<string>();
    public scanReset:Subject<string>  = new Subject<string>();
    public setFolderState:Subject<boolean>  = new Subject<boolean>();
    public setScannerMobileConfigVisibility:Subject<boolean>  = new Subject<boolean>();
    public mobileOrderButtonState:Subject<boolean>  = new Subject<boolean>();
    public chartPreloaderHide:Subject<boolean>  = new Subject<boolean>();

    async emitSymbolChanged(v: {symbol: string, overrideLockAllCharts?: boolean, refreshperiod?:boolean}){
        this.symbolChangedSubscriber.next(v);
    }
    subscribeSymbolChanged(next:(value: {symbol: string, overrideLockAllCharts?: boolean, refreshperiod?:boolean})=>void): Subscription{
        return this.symbolChangedSubscriber.subscribe(next);
    }

    async emitShowGrid(v: boolean){
        this.showGridSubscriber.next(v);
    }
    subscribeShowGrid(next:(value: boolean)=>void): Subscription{
        return this.showGridSubscriber.subscribe(next);
    }
}